import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "20",
  cy: "20",
  r: "20",
  fill: "#D2F9E6"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M17.99 25.98C22.4028 25.98 25.98 22.4028 25.98 17.99C25.98 13.5772 22.4028 10 17.99 10C13.5772 10 10 13.5772 10 17.99C10 22.4028 13.5772 25.98 17.99 25.98Z",
  fill: "#09926C"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M29.9681 23.9901C29.9681 27.2901 27.2881 29.9701 23.9881 29.9701C21.9481 29.9701 20.1581 28.9501 19.0781 27.4001C23.4381 26.9101 26.9081 23.4401 27.3981 19.0801C28.9481 20.1601 29.9681 21.9501 29.9681 23.9901Z",
  fill: "#09926C"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  d: "M19.45 17.7102L17.05 16.8702C16.81 16.7902 16.76 16.7702 16.76 16.4202C16.76 16.1602 16.94 15.9502 17.17 15.9502H18.67C18.99 15.9502 19.25 16.2402 19.25 16.6002C19.25 17.0102 19.59 17.3502 20 17.3502C20.41 17.3502 20.75 17.0102 20.75 16.6002C20.75 15.4502 19.86 14.5102 18.75 14.4602V14.4102C18.75 14.0002 18.41 13.6602 18 13.6602C17.59 13.6602 17.25 13.9902 17.25 14.4102V14.4602H17.16C16.11 14.4602 15.25 15.3402 15.25 16.4302C15.25 17.3802 15.67 17.9902 16.54 18.2902L18.95 19.1302C19.19 19.2102 19.24 19.2302 19.24 19.5802C19.24 19.8402 19.06 20.0502 18.83 20.0502H17.33C17.01 20.0502 16.75 19.7602 16.75 19.4002C16.75 18.9902 16.41 18.6502 16 18.6502C15.59 18.6502 15.25 18.9902 15.25 19.4002C15.25 20.5502 16.14 21.4902 17.25 21.5402V21.6002C17.25 22.0102 17.59 22.3502 18 22.3502C18.41 22.3502 18.75 22.0102 18.75 21.6002V21.5502H18.84C19.89 21.5502 20.75 20.6702 20.75 19.5802C20.75 18.6302 20.32 18.0202 19.45 17.7102Z",
  fill: "#09926C"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import { withDefaults } from 'vue';

interface IProps {
    color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CoinIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_6))
}
}

})